/**
 * Shared typographic glyphs for admin timeline events.
 *
 * Design decision (per plan-design-review + existing BookingTimeline):
 * typographic glyphs in colored circles, NEVER emoji. Emoji render
 * inconsistently across OS/browsers and break the refined-instrument
 * aesthetic documented in DESIGN.md.
 *
 * Used by BookingTimeline.tsx (per-booking view) and UserExplorerView.tsx
 * (per-user activity panel). The EVENT_ICONS map is keyed on the
 * TimelineEventType union so adding a new variant in admin-api.ts
 * forces a compile error here until an icon is added.
 */
import type { TimelineEventType } from '../../lib/admin-api'

export interface TimelineIconStyle {
  icon: string
  color: string
}

export const EVENT_ICONS: Record<TimelineEventType, TimelineIconStyle> = {
  created: { icon: '+', color: 'text-stone-400 bg-stone-100 dark:bg-stone-800' },
  price_check: { icon: '$', color: 'text-stone-400 bg-stone-100 dark:bg-stone-800' },
  drop_detected: { icon: '↓', color: 'text-emerald-600 bg-emerald-50 dark:bg-emerald-900/30' },
  linear_created: { icon: '#', color: 'text-blue-600 bg-blue-50 dark:bg-blue-900/30' },
  linear_resolved: { icon: '✓', color: 'text-emerald-600 bg-emerald-50 dark:bg-emerald-900/30' },
  rebooked: { icon: '✓', color: 'text-emerald-600 bg-emerald-50 dark:bg-emerald-900/30' },
  commission_charged: { icon: '$', color: 'text-emerald-600 bg-emerald-50 dark:bg-emerald-900/30' },
  commission_failed: { icon: '$', color: 'text-red-600 bg-red-50 dark:bg-red-900/30' },
  commission_waived: { icon: '$', color: 'text-stone-400 bg-stone-100 dark:bg-stone-800' },
  commission_refunded: { icon: '$', color: 'text-amber-600 bg-amber-50 dark:bg-amber-900/30' },
  email_received: { icon: '✉', color: 'text-stone-400 bg-stone-100 dark:bg-stone-800' },
  error: { icon: '!', color: 'text-red-600 bg-red-50 dark:bg-red-900/30' },
}

export function iconFor(eventType: TimelineEventType | string): TimelineIconStyle {
  return EVENT_ICONS[eventType as TimelineEventType] ?? EVENT_ICONS.created
}
